/**
 * The studio's About page (`/about`, web-account-pages D8): below 768px the app's About page,
 * which Home's About card opens (Gabriel: Read more opens the About page at its own address),
 * with the app's back button. On a computer the home carries the studio's story, so the address
 * opens the home at its About band.
 */
import { MoveTo, useSiteBack } from '../pageMover';
import { PhoneGuestHome } from '../phone/PhoneGuestHome';
import { useAppScreens } from '../ui/useIsPhone';
import { usePageTitle } from '../ui/usePageTitle';

export function AboutPage() {
  usePageTitle('About');
  const phone = useAppScreens();
  const back = useSiteBack();
  if (phone) return <PhoneGuestHome onBack={back} />;
  return <MoveTo to="/#about" />;
}
